/**
 * Filters out undefined value.
 * To be used with Array.filter as the predicate.
 */
export const filterUndefined = <T>(el: T | undefined): el is T => el !== undefined;

/**
 * Check if a string is a valid URL.
 */
export function isValidURL(url: string | undefined): boolean {
	if (!url) return false;
	try {
		const result = new URL(url);
		return !!result;
	} catch {
		return false;
	}
}
